import { Component, Inject, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  PoseedorControllerService,
  PoseedorEstadoControllerService,
} from 'api-rest';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { HoldersBajaMotivoDialogComponent } from '../holders-baja-motivo-dialog/holders-baja-motivo-dialog.component';

const ESTADO_BAJA_ID = 5;

@Component({
  selector: 'lib-holders-status-change-dialog',
  templateUrl: './holders-status-change-dialog.component.html',
  styleUrls: ['./holders-status-change-dialog.component.scss'],
})
export class HoldersStatusChangeDialogComponent implements OnInit {
  estados: any[] = [];
  poseedores: any[] = [];
  estadoActual: any;

  formGroup!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<HoldersStatusChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private poseedorControllerService: PoseedorControllerService,
    private poseedorEstadoControllerService: PoseedorEstadoControllerService,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService
  ) {
    this.poseedores = this.data.poseedores;
    this.estadoActual = this.data.estadoActual;

    this.formGroup = this.formBuilder.group({
      estado: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
    });
  }

  ngOnInit(): void {
    this.cargarEstados();
    this.cargarEstadoActual();
  }

  cargarEstados(): void {
    this.poseedorEstadoControllerService.findAll6().subscribe({
      next: (data: any) => {
        this.estados = data!;
      },
      error: () => {},
    });
  }

  cargarEstadoActual() {
    this.formGroup.get('estado')?.setValue(this.estadoActual);
  }

  guardar() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    if (this.formGroup.valid) {
      const estadoId = this.formGroup.get('estado')?.value;

      if (estadoId === ESTADO_BAJA_ID) {
        this.abrirDialogoMotivoBaja();
      } else {
        this.actualizarEstadoPoseedores(estadoId);
      }
    } else {
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
    }
  }

  private abrirDialogoMotivoBaja(): void {
    const dialogRef = this.dialog.open(HoldersBajaMotivoDialogComponent, {
      width: '600px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        poseedores: this.poseedores,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.darBajaPoseedores(result.motivoBaja, result.observacionesBaja);
      }
    });
  }

  private darBajaPoseedores(motivoBaja: number, observacionesBaja: string): void {
    const poseedoresId = this.poseedores.map((x) => x.id);
    this.spinnerSrv.loadingShow();

    forkJoin(
      poseedoresId.map((id: any) =>
        this.poseedorControllerService.bajaPoseedor(id)
      )
    ).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar(
          'Se ha cambiado el estado de los poseedores seleccionados.',
          'success'
        );
      },
      error: (err: { message: any }) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al cambiar el estado de los poseedores',
          'error'
        );
      },
    });
  }

  private actualizarEstadoPoseedores(estadoId: number): void {
    const poseedoresId = this.poseedores.map((x) => x.id);
    this.spinnerSrv.loadingShow();

    this.poseedorControllerService
      .multipleActualizarEstado(estadoId, poseedoresId)
      .subscribe({
        next: (value: any) => {
          this.spinnerSrv.loadingHide();
          this.dialogRef.close(true);
          let mensaje =
            'Se ha cambiado el estado de los poseedores seleccionados.';
          if (value && value.length > 0) {
            mensaje = mensaje + '\n' + value.join('\n');
          }
          this.snackBarSrv.showSnackBar(mensaje, 'success');
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al cambiar el estado de los poseedores',
            'error'
          );
        },
      });
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  controlHasErrorSelect(controlName: string) {
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      return true;
    } else {
      return false;
    }
  }
}
